export const achievementData = {
  bio: "Putting quantified achievements on a resume is great, but I just don’t work with hard numbers. I have no data to support the quality of my work. If you have lots of relevant experience, the heading statement of your resume will be a summary.",
  achievements: [
    {
      id: 1,
      title: "Software Engineering Virtual ExperienceProgram",
      details:
        "This program by Goldman Sachs helps to learn more about cryptography and password cracking.",
      date: "April 29, 2023",
      field: "Cryptography basics",
      image: "https://www.goldmansachs.com/a/pgs/images/logo.png",
    },
    {
      id: 2,
      title: "Project Management Skills for Leaders",
      details:
        "Project Management Skills for Leaders by Linkedin helps to gain project management skills to succeed at a leadership level.",
      date: "Feb 20, 2023",
      field: "Management",
      image:
        "https://pbs.twimg.com/profile_images/1508518003184349187/1KQYoqPY_400x400.png",
    },
    {
      id: 3,
      title: "The Fundamentals of Digital Marketing",
      details:
        "The Fundamentals of Digital Marketing by Google helps to learn more about the basics of digital marketing.",
      date: "July 18, 2022",
      field: "Digital Marketing",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/800px-Google_2015_logo.svg.png",
    },
    {
      id: 4,
      title: "Learn Ethical hacking from Scratch",
      details:
        "Learn Ethical hacking from Scratch by Udemy helps to learn more about the basics of ethical hacking and tools used in ethical hacking using inbuilt tools in kali linux.",
      date: "Aug 13, 2020",
      field: "Ethical Hacking",
      image: "https://s.udemycdn.com/meta/default-meta-image-v2.png",
    },
  ],
};


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/